const testHosts = ['localhost', 'test.runnermaps.nl'];

export const IS_TEST = testHosts.includes(window.location.hostname);

export const API2_ORIGIN = window.location.hostname.includes('runnermaps')
  ? window.location.origin
  : 'https://test.runnermaps.nl';

export const API2_URL = `${API2_ORIGIN}/api`;

export const FILES_ORIGIN = 'https://files.runnermaps.nl';
